
(function () {
  function initMedLinksAccordion(scope) {
    var accordions = (scope || document).querySelectorAll('[data-ml-product-accordion]');

    accordions.forEach(function (accordion) {
      if (accordion.dataset.initialized === 'true') return;
      accordion.dataset.initialized = 'true';

      var items = Array.from(accordion.querySelectorAll('.ml-detail-item'));
      items.forEach(function (item, index) {
        var trigger = item.querySelector('.ml-detail-trigger');
        var panel = item.querySelector('.ml-detail-panel');

        if (!trigger || !panel) return;
        panel.id = 'ml-detail-' + (accordion.closest('[data-block-id]') || accordion).getAttribute('data-block-id') + '-' + index;
        trigger.setAttribute('aria-controls', panel.id);
        panel.setAttribute('aria-hidden', String(!item.classList.contains('is-open')));

        if (item.classList.contains('is-open')) {
          panel.style.height = 'auto';
          trigger.setAttribute('aria-expanded', 'true');
        } else {
          panel.style.height = '0px';
          trigger.setAttribute('aria-expanded', 'false');
        }

        trigger.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');

          if (isOpen) {
            panel.style.height = panel.scrollHeight + 'px';

            requestAnimationFrame(function () {
              item.classList.remove('is-open');
              trigger.setAttribute('aria-expanded', 'false');
              panel.setAttribute('aria-hidden', 'true');
              panel.style.height = '0px';
            });
          } else {
            item.classList.add('is-open');
            panel.setAttribute('aria-hidden', 'false');
            trigger.setAttribute('aria-expanded', 'true');
            panel.style.height = panel.scrollHeight + 'px';
          }
        });

        panel.addEventListener('transitionend', function () {
          if (item.classList.contains('is-open')) {
            panel.style.height = 'auto';
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initMedLinksAccordion(document); });
  } else {
    initMedLinksAccordion(document);
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches('[data-ml-product-accordion]')) initMedLinksAccordion(node.parentElement);
        else if (node.querySelector('[data-ml-product-accordion]')) initMedLinksAccordion(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', function (event) {
    initMedLinksAccordion(event.target);
  });
})();
